import { useEffect, useState } from 'react';

const POLL_INTERVAL_MS = 5 * 60 * 1000;

async function fetchBuildId(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const data: { buildId?: string } = await res.json();
    return data.buildId ?? null;
  } catch {
    return null;
  }
}

/**
 * Compara la key del build publicado (`version.json`) con la del bundle que
 * está corriendo (`__BUILD_ID__`). Si difieren, hay una versión nueva.
 */
export function useVersionCheck(): { updateAvailable: boolean } {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let stopped = false;
    const interval = setInterval(() => void check(), POLL_INTERVAL_MS);

    async function check(): Promise<void> {
      const buildId = await fetchBuildId();
      if (stopped || buildId === null || buildId === __BUILD_ID__) return;
      stopped = true;
      clearInterval(interval);
      setUpdateAvailable(true);
    }

    void check();

    return () => {
      stopped = true;
      clearInterval(interval);
    };
  }, []);

  return { updateAvailable };
}
